// Shared types for the in-app notification inbox (bell + panel).
import {InAppNotificationStatus} from 'graphql-client/__generated/graphqlGlobalTypes';

// Re-export the generated status enum so callers in this feature import it from one place.
export {InAppNotificationStatus};

// A single notification as consumed by the inbox UI. Mirrors the fields on `InAppNotificationNode`
// exposed by `inAppNotificationListing`.
export interface InAppNotification {
  id: string;
  status: InAppNotificationStatus;
  title: string;
  body: string | null;
  actorApiId: string | null;
  resourceApiId: string | null;
  lastEventAt: string;
  readAt: string | null;
  dismissedAt: string | null;
}

// The tab a user is viewing in the panel. "All" shows every non-dismissed notification; "Unread"
// filters to unread only. Kept separate from `InAppNotificationStatus` because a tab is a view
// filter, not a persisted state.
export enum NotificationTab {
  ALL = 'all',
  UNREAD = 'unread',
}

// Above this many unread, the badge shows a capped "9+" rather than the exact count.
export const MAX_EXACT_BADGE_COUNT = 9;

// Render the unread badge text, or null when the badge should be hidden (zero unread).
export function getBadgeText(unreadCount: number): string | null {
  if (unreadCount <= 0) {
    return null;
  }
  return unreadCount > MAX_EXACT_BADGE_COUNT ? `${MAX_EXACT_BADGE_COUNT}+` : String(unreadCount);
}
